import React from 'react'

import aboutYou from '../../../assets/about-page.svg'

import CitizenshipStatusContainer from '../../containers/CitizenshipStatusContainer'
import CitizenshipStatusByCountryForm from '../../components/CitizenshipStatusByCountryForm'
import Card from '../../components/Card'
import SkeletonCitizenshipStatus from '../../skeletons/SkeletonCitizenshipStatus'

const CitizenshipStatusScene = () => {
  return (
    <CitizenshipStatusContainer>
      {({
        isLoadingCandidates,
        candidateProfileError,
        countryBasedCitizenships,
        location,
        history,
        reduxChangeUrl,
        candidateId,
        preferredCountries,
      }) => (
        <Card title="Work authorisation" imageUrl={aboutYou} width={550}>
          <Choose>
            <When condition={isLoadingCandidates || !!candidateProfileError}>
              <SkeletonCitizenshipStatus />
            </When>
            <Otherwise>
              <CitizenshipStatusByCountryForm
                regionalCitizenships={countryBasedCitizenships}
                candidateId={candidateId}
                location={location}
                history={history}
                reduxChangeUrl={reduxChangeUrl}
                preferredCountries={preferredCountries}
                nextUrl="/candidate/salary-expectations"
              />
            </Otherwise>
          </Choose>
        </Card>
      )}
    </CitizenshipStatusContainer>
  )
}

export default CitizenshipStatusScene
